import { useState } from 'react';

import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';

import { getSystem } from '@/system';
import { iconsClose } from '@/utils/icons';

import { useAccessibility } from '../Accessibility/AccessibilityContext';

interface ModalCloseProps {
  text: string;
  focusKey: string;
  onClick: () => void;
  styleClasses?: string;
}

const ModalClose: React.FC<ModalCloseProps> = ({
  text,
  focusKey,
  onClick,
  styleClasses,
}) => {
  const system = getSystem();
  const { announceToScreenReader } = useAccessibility();
  const { ref, focused, focusSelf } = useFocusable({
    focusKey,
    onEnterPress: () => onClick(),
    onFocus: () => {
      if (!system.overrideAria) ref?.current?.focus;
      if (text) announceToScreenReader(text);
    },
    onBlur: () => {
      if (!system.overrideAria) ref?.current?.blur;
      if (text) announceToScreenReader('');
    },
  });

  return (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      className={`border-none outline-none p-2 transition-all ${focused ? 'bg-[#565656]' : 'bg-transparent'} ${styleClasses}`}
      onMouseOver={() => {
        focusSelf();
      }}
      aria-label={text}
    >
      <img className={`w-8 h-8`} src={iconsClose} alt="" />
    </button>
  );
};

export default ModalClose;
